import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { ConsultantAdviserContent } from '@/components/modules/pages/rfp/client/Content/ConsultantAdviserContent';
import { Card } from '@/components/ui/Surface/Card';
import { propBool, propId, propShape, propStr, } from '../../../../../../helpers/custom-prop-types';
import ModalPortal from '../../../../../Ui/Modal/ModalPortal';
import AdviserModal from './AdviserModal';
const ConsultantAdviser = (props) => {
    const { admin, className, id, isLarge, showDescriptionBox, showTitle, useCase, } = props;
    const { first_name: firstName, hubspot_calendar: hubspotCalendar, last_name: lastName, phone1, phone2, phone3, photo, } = admin;
    const dispatch = useDispatch();
    const { hideModal, isDisabled, isShow, onSubmit, showModal } = useCase.useModal(id, dispatch);
    return (_jsxs(_Fragment, { children: [_jsx(Card, Object.assign({ className: clsx('p-16', 'sm:rounded-md', className), isShadow: !isLarge }, { children: _jsx(ConsultantAdviserContent, { avatarSrc: photo || '', calendarButtonLink: hubspotCalendar, firstName: firstName, isDisabledMailButton: isDisabled, isLarge: isLarge, lastName: lastName, onClickMailButton: showModal, phone1: phone1, phone2: phone2, phone3: phone3, showDescriptionBox: showDescriptionBox, showTitle: showTitle }) })), _jsx(ModalPortal, { children: _jsx(AdviserModal, { hideModal: hideModal, isShow: isShow, onSubmit: onSubmit }) })] }));
};
ConsultantAdviser.propTypes = {
    admin: propShape().isRequired,
    className: propStr(),
    id: propId().isRequired,
    isLarge: propBool(),
    showDescriptionBox: propBool(),
    showTitle: propBool(),
    useCase: propShape().isRequired,
};
ConsultantAdviser.defaultProps = {
    className: '',
    isLarge: false,
    showDescriptionBox: true,
    showTitle: true,
};
export default ConsultantAdviser;
